module.exports = __webpack_public_path__ + "packs/media/images/bg-ef6b27245fb05d136a7bc46042da2eb7.jpg";